var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Suspense } from 'react';
import MobileHeader, { MobileHeaderSkeleton, } from '@dev-togetherprice/components.mobile-header';
import DesktopHeader, { DesktopHeaderSkeleton, } from '@dev-togetherprice/components.desktop-header';
const FullTopAppBar = (_a) => {
    var { desktopProps = {}, mobileProps = {}, classes } = _a, commonProps = __rest(_a, ["desktopProps", "mobileProps", "classes"]);
    const passingDesktopProps = Object.assign(Object.assign(Object.assign({}, commonProps), desktopProps), { classes: Object.assign(Object.assign({}, desktopProps === null || desktopProps === void 0 ? void 0 : desktopProps.classes), classes) });
    const passingMobileProps = Object.assign(Object.assign(Object.assign({}, commonProps), mobileProps), { classes: Object.assign(Object.assign({}, mobileProps === null || mobileProps === void 0 ? void 0 : mobileProps.classes), classes) });
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: React.createElement(DesktopHeaderSkeleton, Object.assign({}, passingDesktopProps)) },
            React.createElement(DesktopHeader, Object.assign({}, passingDesktopProps))),
        React.createElement(Suspense, { fallback: React.createElement(MobileHeaderSkeleton, Object.assign({}, passingMobileProps)) },
            React.createElement(MobileHeader, Object.assign({}, passingMobileProps)))));
};
export default FullTopAppBar;
